import { onUnmounted } from "vue";

/**
 * Run `fn` every `interval` ms while the tab is visible. A hidden tab stops the timer and a
 * returning one runs `fn` immediately, so the first thing the user sees is current.
 *
 * @param {() => unknown} fn
 * @param {number} interval - milliseconds between runs
 * @returns {{ restart: () => void }}
 */
export function useIntervalWhenVisible(fn, interval) {
  let timer = null;

  function stop() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  function restart() {
    stop();
    if (document.hidden) return;
    timer = setInterval(() => fn(), interval);
  }

  function onVisibilityChange() {
    if (document.hidden) {
      stop();
    } else {
      fn();
      restart();
    }
  }

  restart();
  document.addEventListener("visibilitychange", onVisibilityChange);

  onUnmounted(() => {
    stop();
    document.removeEventListener("visibilitychange", onVisibilityChange);
  });

  return { restart };
}
